import React, {useState, useEffect} from 'react'
import * as RouterActions from '../../actions/RouterActions'
import * as SportsActions from '../../actions/rmg/SportsActions'
import * as MarketsActions from '../../actions/rmg/MarketsActions'
import * as CategoriesActions from '../../actions/rmg/CategoriesActions'
import * as TournamentsActions from '../../actions/rmg/TournamentsActions'
import * as EventsActions from '../../actions/rmg/EventsActions'
import {Table, Label, List, Popup, Icon, Loader, Button} from 'semantic-ui-react'
import {useDispatch, useSelector} from 'react-redux';
import * as moment from 'moment'
import {env} from '../../constants/Environment';
import {RmgNavigation} from './Navigation';

const _ = require('lodash');

export const Browser = (props) => {
    moment.locale('de');
    
    const dispatch = useDispatch()
    const sports = useSelector(({rmg_sports}) => rmg_sports);
    const markets = useSelector(({rmg_markets}) => rmg_markets);
    const categories = useSelector(({rmg_categories}) => rmg_categories);
    const tournaments = useSelector(({rmg_tournaments}) => rmg_tournaments);
    const events = useSelector(({rmg_events}) => rmg_events);

    useEffect(() => {
        if(sports.sports === null && sports.loading === false){
            dispatch(SportsActions.load());
        }
    }, [sports.sports === null]);

    useEffect(() => {
        if(props.match.params.sportIdForMarkets){
            dispatch(MarketsActions.load(props.match.params.sportIdForMarkets));
        }
    }, [props.match.params.sportIdForMarkets])

    useEffect(() => {
        if(typeof props.match.params.sportIdForCategories !== 'undefined'){
            dispatch(EventsActions.load([props.match.params.sportIdForCategories], moment().startOf('day').valueOf()));
        }
    }, props.match.params)

    useEffect(() => {
        if(props.match.params.sportIdForCategories){
            dispatch(CategoriesActions.load(props.match.params.sportIdForCategories));
        }
    }, [props.match.params.sportIdForCategories])

    useEffect(() => {
        if(props.match.params.sportIdForTournaments && props.match.params.categoryIdForTournaments){
            dispatch(TournamentsActions.load(props.match.params.sportIdForTournaments, props.match.params.categoryIdForTournaments));
        }
    }, [props.match.params.sportIdForTournaments, props.match.params.categoryIdForTournaments])

    return (
        <RmgNavigation breadcrumb={[
            {
                'caption': 'RMG',
                'href': '/rmg/'
            },
            {
                'caption': 'Browser',
                'href': '/rmg/browser/'
            },
            ...(props.match.params.sportIdForMarkets && sports.sports !== null)?
                [{
                    'caption': sports.sports.find((s) => String(s.id) === props.match.params.sportIdForMarkets).name.text,
                    href: '/rmg/browser/'
                }, {
                    'caption': 'Märkte'                    
                }]:[]
        ]} active="rmg">
            <div style={{
                padding: '0.5em',
                paddingTop: '1em'
            }}>
                {
                    (props.match.params.sportIdForMarkets && markets.markets !== null)?
                        <div>
                            {
                                markets.markets.map((market) => {
                                    return <div onClick={(e) => {
                                        dispatch(RouterActions.push('/rmg/browser/' + sport.id + '/markets'));
                                    }}>{[
                                        market.id,
                                        market.name,
                                        market.happening,
                                        market.period,
                                        market.value,
                                        market.isBalancedLine?'Balanced Line':''
                                    ].join(' , ')}</div>
                                })
                            }
                        </div>
                    :
                        (
                            <div style={{
                                display: 'flex'
                            }}>
                                <div style={{
                                    width: '500px'
                                }}>
                            {
                                (props.match.params.sportIdForCategories && categories.categories !== null)?
                                    <Table>
                                        {
                                            categories.categories.map((category) => {
                                                return <Table.Row>
                                                    <Table.Cell>
                                                        <a onClick={(e) => {
                                                            dispatch(RouterActions.push('/rmg/browser/' + props.match.params.sportIdForCategories + '/categories/' + category.id + '/tournaments'));
                                                        }}>{category.name.text}</a>
                                                    </Table.Cell>
                                                </Table.Row>
                                            })
                                        }
                                    </Table>
                                :
                                    (props.match.params.sportIdForTournaments && props.match.params.categoryIdForTournaments && tournaments.tournaments !== null)?
                                        <Table>
                                            {
                                                tournaments.tournaments.map((tournament) => {
                                                    return <Table.Row>
                                                        <Table.Cell>
                                                            {tournament.name.text}
                                                        </Table.Cell>
                                                        <Table.Cell>
                                                            <a onClick={(e) => {
                                                                dispatch(RouterActions.push('/rmg/browser/' + props.match.params.sportIdForTournaments + '/categories/' + props.match.params.categoryIdForTournaments + '/tournaments/' + tournament.id + '/events'));
                                                            }}>Events</a>
                                                        </Table.Cell>
                                                    </Table.Row>
                                                })
                                            }
                                        </Table>
                                    :
                                    (sports.sports !== null)?
                                        <Table>
                                            {
                                                sports.sports.map((sport) => {
                                                    return <Table.Row>
                                                        <Table.Cell><a onClick={(e) => {
                                                            dispatch(RouterActions.push('/rmg/browser/' + sport.id + '/categories'));
                                                        }}>{sport.name.text}</a></Table.Cell>
                                                        <Table.Cell><a style={{cursor: 'pointer'}} onClick={(e) => {
                                                            dispatch(RouterActions.push('/rmg/browser/' + sport.id + '/markets'));
                                                        }}>Märkte</a></Table.Cell>
                                                        <Table.Cell><a onClick={(e) => {
                                                            dispatch(RouterActions.push('/rmg/browser/' + sport.id + '/events'));
                                                        }}>Events</a></Table.Cell>
                                                    </Table.Row>
                                                })
                                            }
                                        </Table>
                                    :null
                            }
                                </div>
                                <div style={{
                                    flexGrow: 1
                                }}>
                                    {
                                        (events.events)?
                                            <Table>
                                            {
                                                events.events.map((event) => {
                                                    return (
                                                        <Table.Row>
                                                            <Table.Cell>
                                                                {event.event.startDateUtc}
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                {event.event.name.text}
                                                            </Table.Cell>
                                                        </Table.Row>        
                                                    )
                                                })
                                            }
                                            </Table>                                            
                                        :null
                                    }
                                </div>
                            </div>
                        )
                }
            </div>
        </RmgNavigation>
    )
}